import { z } from "zod";

export const CbomKeysSchema = z.object({
  k_id: z.number().int().optional(),
  device_id: z.string().optional(),
  file_path: z.string().optional(),
  key_type: z.string().optional(),
  algorithm: z.string().optional(),
  key_length: z.number().int().optional(),
  curve_name: z.string().optional(),
  format: z.string().optional(),
  quantum_safe_status: z.string().optional(),
  target_algorithm: z.string().optional(),
  compliance_status: z.string().optional(),
  cbom_json: z.record(z.any()).optional(),
});

export type CbomKeys = z.infer<typeof CbomKeysSchema>;
